import { FormGroup, ValidationErrors } from "@angular/forms";

export function passwordMatchValidator(
  controlName: string,
  matchingControlName: string
) {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const passwordControl = formGroup.get(controlName);
    const confirmPasswordControl = formGroup.get(matchingControlName);

    if (
      passwordControl
      && confirmPasswordControl
      && passwordControl.value !== confirmPasswordControl.value
    ) {
      // Return an error object if validation fails
      confirmPasswordControl.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }

    return null;
  };
}
